// import Demo from '../demo/Demo'

import Home_five from '../pages/Home_five'
import NotFound from '../pages/404'

export const routes = [
    {
        path:'*',
        name: 'NotFound',
        component: NotFound
    },
    {
        path:'/',
        name: 'Home_five',
        component: Home_five
    }
];